import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { FloatingCTAs } from "./FloatingCTAs";
import { ScrollToTop } from "../common/ScrollToTop";

export const Layout = ({ children }) => {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        window.__lenis = lenis;
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-[#f8fafc]">
            <ScrollToTop />
            <Navbar />
            <main>{children}</main>
            <Footer />
            <FloatingCTAs />
        </div>
    );
};
